import { SELLER_MODAL_XSELL } from 'shared/experiments/consts'
import { getExperimentOnClient } from 'shared/experiments/utils/experiments'

export const isXsellSellerModalActive = () => {
  const { isEnabled, variant } = getExperimentOnClient(SELLER_MODAL_XSELL)

  return isEnabled && variant === 'v1'
}
